































import Vue, { PropType } from "vue";
import { InputLogoFileInterface } from "@/model/components/InputLogoFileInterface.ts";
import Api from "@/gateway/api.ts";

export default Vue.extend({
  name: "InputLogoFile",

  props: {
    input: {
      type: Object as PropType<InputLogoFileInterface>,
      required: true
    }
  },

  methods: {
    click(): void {
      const input = document.getElementById(this.input.label);
      if (input) {
        input.click();
      }
    },

    remove() {
      (document.querySelector(
        `#${this.input.label}`
      ) as HTMLInputElement).value = "";

      this.$emit("update", {
        ...this.input,
        filename: "",
        original: "",
        error: ""
      });
    },

    async update(
      e: Event & {
        currentTarget: HTMLInputElement;
        dataTransfer: DataTransfer;
      }
    ) {
      const files = e.currentTarget.files || e.dataTransfer.files;

      if (files.length === 0) {
        return;
      }

      const file = files[0];
      let res;
      let input: InputLogoFileInterface;

      try {
        res = await Api.upload(file);
        input = Object.assign({}, this.input, {
          filename: res.filename,
          original: file.name,
          error: ""
        });
      } catch (err) {
        console.error(err.response.data);
        input = Object.assign({}, this.input, {
          error: err.response.data.message
        });
      }

      this.$emit("update", input);
    }
  }
});
